import InboundIpAddresses from "../../../../contents/docs/cdp/_snippets/inbound-ip-addresses.mdx";
import * as React from 'react';
export default {
  InboundIpAddresses,
  React
};